// extracted by mini-css-extract-plugin
export default {"loader":"peA3A","rotation":"_63wcO","container":"dEoqI","dot":"rB9U1","one":"_9BpNE","two":"_9ybdU","three":"_30AHs"};